import { inject } from '@angular/core';
import type { Route } from '@angular/router';
import { PermissionService } from '../../../../../core/services/permission.service';
import { ReportOptionsStore } from './shared/report-options.store';
import { REPORTS_SEGMENT_LIST, reportsLandingUrl } from './shell/reports-segments';

/** `/benefits/reports` (SP6 D10): its own shell and segments. `BENEFITS_ROUTE` registers it and adds `permissionGuard` (Q9 precedent). */
export const REPORTS_ROUTE: Route = {
  path: 'reports',
  // One options load per Reports visit (ruling R3); the store resets when the user leaves /benefits/reports.
  providers: [ReportOptionsStore],
  loadComponent: () => import('./shell/reports-shell.component').then((m) => m.ReportsShellComponent),
  children: [
    {
      path: '',
      pathMatch: 'full',
      redirectTo: () => {
        const permissions = inject(PermissionService);
        return reportsLandingUrl((anyOf) => permissions.hasAny(anyOf), inject(REPORTS_SEGMENT_LIST));
      },
    },
    { path: 'utilization', loadComponent: () => import('./utilization/utilization-report-page.component').then((m) => m.UtilizationReportPageComponent) },
    { path: 'categories', loadComponent: () => import('./categories/categories-report-page.component').then((m) => m.CategoriesReportPageComponent) },
    { path: 'costs', loadComponent: () => import('./costs/costs-report-page.component').then((m) => m.CostsReportPageComponent) },
    {
      path: 'enrollment-roster',
      loadComponent: () => import('./enrollment-roster/enrollment-roster-report-page.component').then((m) => m.EnrollmentRosterReportPageComponent),
    },
    { path: 'renewal', loadComponent: () => import('./renewal/renewal-report-page.component').then((m) => m.RenewalReportPageComponent) },
  ],
};
